import React, { useRef, useState, useEffect } from 'react';
import AWS from 'aws-sdk';
import axios from 'axios';
import Swal from 'sweetalert2';
import svasti_logo from '../../assests/Login/cropped-Svasti mCRO Logo Final 2025 01 15-02.jpg';
import svasti_logo_footer from "../../assests/Login/Svasti-Logo.jpg";
import { useNavigate } from 'react-router-dom';
import { saveLogEvent, formatCustomDate } from '../../utils/Utils';
import { UAParser } from 'ua-parser-js';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { v4 as uuidv4 } from 'uuid';


const COMPARE_SERVER_URL = "https://sfr.svasti.in/api/request/faceCompare";
const GEOLOCATION_API_URL = "https://ipapi.co/json/";
let sessionTimer = null;

const alertMessages = (alertMsg) => {
    Swal.fire({
        title: alertMsg,
        confirmButtonColor: '#fdba14',
        width: 250,
    }).then(() => {
        sessionStorage.clear(); // Clears all session storage data
    });
};


// Generate or retrieve session ID
const getSessionId = () => {
    let sessionId = sessionStorage.getItem("sessionId");
    if (!sessionId) {
        sessionId = uuidv4();
        sessionStorage.setItem("sessionId", sessionId);
    }
    return sessionId;
};

const getDeviceId = async () => {
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    return result.visitorId;
};

const Login = () => {
    const navigate = useNavigate();
    const videoRef = useRef(null);
    const [isValidating, setIsValidating] = useState(false);
    const [flag, setFlag] = useState(false);
    const [customerNumber, setCustomerNumber] = useState('');
    const [isInputDisabled, setIsInputDisabled] = useState(false);
    const [deviceId, setDeviceId] = useState('');

    let recordedChunks = [];

    const startSessionTimeout = (timeoutMinutes = 15) => {
        const resetTimer = () => {
            if (sessionTimer) clearTimeout(sessionTimer);
            sessionTimer = setTimeout(() => {
                Swal.fire({
                    title: 'Session Expired',
                    text: 'You have been logged out due to inactivity.',
                    confirmButtonColor: '#fdba14',
                }).then(() => {
                    sessionStorage.clear();
                    localStorage.clear();
                    navigate("/login");
                });
            }, timeoutMinutes * 60 * 1000);
        };

        const events = ['click', 'mousemove', 'keydown', 'scroll', 'touchstart'];
        events.forEach(event => {
            window.removeEventListener(event, resetTimer);
            window.addEventListener(event, resetTimer);
        });

        resetTimer();
    };


    const getDeviceDetails = async () => {
        const parser = new UAParser();
        const result = parser.getResult();

        let deviceModel = result.device.model || "Unknown";
        let deviceVendor = result.device.vendor || "Unknown";

        // Check if userAgentData is available (for Chrome/Edge browsers)
        if (navigator.userAgentData) {
            try {
                const uaData = await navigator.userAgentData.getHighEntropyValues(["model", "platform", "platformVersion"]);
                if (uaData.model) {
                    deviceModel = uaData.model;
                }
                if (uaData.platform) {
                    result.os.name = uaData.platform;
                }
                if (uaData.platformVersion) {
                    result.os.version = uaData.platformVersion;
                }
            } catch (error) {
                console.error("Error fetching high-entropy values:", error);
            }
        }

        // Fallback for other browsers using userAgent string
        if (deviceModel === "Unknown") {
            const userAgent = navigator.userAgent || "";
            if (/iPhone/i.test(userAgent)) {
                deviceModel = "iPhone";
            } else if (/iPad/i.test(userAgent)) {
                deviceModel = "iPad";
            } else if (/Samsung/i.test(userAgent)) {
                deviceVendor = "Samsung";
            } else if (/Pixel/i.test(userAgent)) {
                deviceVendor = "Google Pixel";
            } else if (/OnePlus/i.test(userAgent)) {
                deviceVendor = "OnePlus";
            }
        }

        return {
            browser: result.browser.name,
            browserVersion: result.browser.version,
            os: result.os.name,
            osVersion: result.os.version,
            deviceType: result.device.type || "Mobile",
            deviceVendor: deviceVendor,
            deviceModel: deviceModel,
            userAgent: navigator.userAgent,
        };
    };

    const fetchLocation = async () => {
        try {
            const response = await axios.get(GEOLOCATION_API_URL);
            return response.data;
        } catch (error) {
            console.error("Error fetching location:", error);
            return null;
        }
    };

    const logPageLoad = async () => {
        try {
            const details = await getDeviceDetails(); // Wait for device details
            saveLogEvent({
                logLevel: "info",
                statusCode: 200,
                status: "success",
                message: {
                    trigger: "Login Page Loaded",
                    Page: "Login Page",
                },
                payload: {
                    timestamp: formatCustomDate(new Date().toISOString()),
                    deviceDetails: details, // Ensure device details are fully populated
                    trigger: "Login Page Loaded",
                    Page: "Login Page",
                    accessMethod: sessionStorage.getItem("accessMethod")||"URL" // Store the access method
                    
                },
            });
        } catch (error) {
            console.error("Error fetching device details for logging:", error);
        }
    };
    const fetchDeviceId = async () => {
        const deviceId = localStorage.getItem("deviceId");
       if(!deviceId){
        const id = await getDeviceId();
        setDeviceId(id);
        localStorage.setItem("deviceId", id);
       }
       else return  setDeviceId(deviceId);
    };

    useEffect(() => {
        fetchDeviceId();
        logPageLoad();
    }, []);


    const startRecording = async () => {
        const StartTime = Date.now()
        console.log("Starttime :", StartTime)
        sessionStorage.setItem("startTime", StartTime);
        setFlag(!flag);
        try {
            const stream = await navigator.mediaDevices.getUserMedia({
                video: {
                    facingMode: 'user',
                    frameRate: { max: 15 }, // Request 15 FPS

                },
                audio: false
            });
            videoRef.current.srcObject = stream;
            const videoTrack = stream.getVideoTracks()[0];
            const settings = videoTrack.getSettings();

            console.log("Video Track Settings:", settings);
            // alert(`Actual FPS: ${settings.frameRate}`);
            var recorder = new MediaRecorder(stream);
            recorder.ondataavailable = (event) => {
                if (event.data.size > 0) {
                    recordedChunks.push(event.data);
                }
            };
            recorder.start();

            setTimeout(() => {
                stopRecording(recorder, stream);
            }, 5000);
        } catch (err) {
            console.error('Error accessing camera:', err);
        }
    };

    const stopRecording = async (recorder, stream) => {
        recorder.stop();
        stream.getTracks().forEach(track => track.stop());
        setIsValidating(true);

        recorder.onstop = async () => {
            let recorded_fileName = Date.now() + '-' + Math.floor(Math.random() * 1000) + '.webm';
            const blob = new Blob(recordedChunks, { type: 'video/webm' });
            const file = new File([blob], recorded_fileName, { type: 'video/webm' });

            const params = {
                Bucket: 'svastivideos',
                Key: recorded_fileName,
                Body: file,
                ContentType: 'video/webm',
            };

            const s3 = new AWS.S3({
                apiVersion: '2006-03-01',
                params: { Bucket: 'svastivideos' }
            });

            try {
                await s3.upload(params).promise();
                await verifyVideo(recorded_fileName);
            } catch (error) {
                console.error('Error uploading video:', error);
            }
        };
    };

    const verifyVideo = async (fileName) => {
        try {
            var config = {
                headers: { 'Content-Type': 'application/json' },
                params: {
                    video_file: fileName,
                    customer_number: customerNumber
                }
            };

            const response = await axios.post(COMPARE_SERVER_URL, {}, config);
            const result = await response.data;
            const eventRemarks = JSON.parse(result.data.EventRemarks2);
            const eventRemarks1 =JSON.parse(result.data.EventRemarks1)
            const location = await fetchLocation();
            const { latitude, longitude } = location;
            getSessionId();
            if (validate(eventRemarks)) {
                const customerId = eventRemarks.names[0];
                sessionStorage.setItem("SvastiUserID", JSON.stringify(customerId));

                const startTime = sessionStorage.getItem("startTime");

                saveLogEvent({
                    logLevel: "info",
                    statusCode: 200,
                    status: "success",
                    message: {
                        result: "Success",
                        Page: "Login Page",
                        customerNumber: customerNumber,
                        trigger: "On evaluation of login",
                    },
                    payload: {
                        timestamp: formatCustomDate(new Date().toISOString()),
                        deviceDetails: await getDeviceDetails(),
                        sessionId: sessionStorage.getItem("sessionId"),
                        location: { latitude, longitude },
                        trigger: "On evaluation of login",
                        Page: "Login Page",
                        deviceId
                    },
                });
                startSessionTimeout();
                navigate("/");
                const endTime = Date.now();
                console.log("StartTime :", startTime, "  ", "EndTime :", endTime)
                const duration = (endTime - startTime) / 1000;
                console.log("TotalDuration :", duration)
            } else {
                let failureReason = {ui:"Face recognition mismatch",log:"Face recognition mismatch"};

                // Determine failure reason based on EventRemarks1
                if (eventRemarks1?.image_indexed === false) {
                    failureReason = {ui:"Customer record not available. Please contact the branch or try again later.", log:"Customer Not Indexed"};
                } else if (eventRemarks1?.image_indexed === true) {
                    failureReason = {ui:"Validation Failed - Please try again.", log:"No Match Found"};
                } else if (eventRemarks1?.error) {
                    failureReason = {ui:'There is a technical issue, please try again later.',log:"Missing Video Error"};
                } else {
                    failureReason = {ui:"Unknown Error - Please try again",log:"Unknown Error - Please try again"};
                }

                // Show alert
                alertMessages(`${customerNumber} - ${failureReason.ui}`);
                setCustomerNumber('');
                setIsInputDisabled(false);
                setIsValidating(false);
                setFlag(false);

                saveLogEvent({
                    logLevel: "error",
                    statusCode: 401,
                    status: "failure",
                    customerNumber,
                    message: {
                        customerNumber: customerNumber,
                        trigger: "On evaluation of login",
                        result: "Failure",
                        Page: "Login Page",
                    },
                    payload: {
                        timestamp: formatCustomDate(new Date().toISOString()),
                        deviceDetails: await getDeviceDetails(),
                        sessionId: sessionStorage.getItem("sessionId"),
                        location: { latitude, longitude },
                        trigger: "On evaluation of login",
                        result: "Failure",
                        failureReason:failureReason.log,
                        EventRemarks1:eventRemarks1,
                        Page: "Login Page",
                        deviceId
                    },
                });
            }
        } catch (error) {
            console.error('Error verifying video:', error);
            setIsValidating(false);
        }
    };

    const validate = (eventRemarks) => {
        return eventRemarks && eventRemarks.faceCount === 1 && eventRemarks.names[0];
    };

    const handleLoginClick = async () => {
        startRecording();
        setIsInputDisabled(true);
        sessionStorage.clear()
        saveLogEvent({
            logLevel: "info",
            statusCode: 200,
            status: "success",
            customerNumber,
            message: {
                Page: "Login Page",
                customerNumber: customerNumber,
                trigger: 'On click of button "Login',
            },
            payload: {
                timestamp: formatCustomDate(new Date().toISOString()),
                deviceDetails: await getDeviceDetails(),
                trigger: 'On click of button "Login"',
                Page: "Login Page",
                deviceId
            },
        });
    };
    return (
        <div className="flex flex-col items-center justify-between bg-[#fdba14] h-[100vh]">
            <img src={svasti_logo} alt="Svasti Logo" className="w-[80%] mt-4 mb-2" />
            <div className="text-center text-2xl py-2 my-2 bg-[#FAECE7] border-1 border-black rounded-[10px] w-[60%]">
                <strong>मेरा</strong> स्वस्ति
            </div>
            <div className="flex flex-col items-center justify-center w-full flex-grow">
                <video ref={videoRef} className={`${isValidating ? "hidden" : ""} border-2 border-black bg-[wheat] w-[70%] h-[25vh]`} autoPlay playsInline></video>
                <div id="response" className={`${isValidating ? "hidden" : ""} w-[70%] text-center my-4 leading-[1.65] font-gotham-rounded`}>
                    ⓘ Keep only one face in front of the Camera for Login
                </div>
                {isValidating && (
                    <div className="my-4 text-center text-black leading-[1.65] font-gotham-rounded">
                        <div className="flex items-center justify-center">
                            <svg className="animate-spin h-6 w-6 mr-3" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
                            </svg>
                            Validation in progress......
                        </div>
                    </div>
                )}
                <div className="flex flex-col items-center w-[70%] mb-4">
                    <label htmlFor="customerId" className={`${isValidating ? "hidden" : ""} mr-2 font-gotham-rounded`}>Customer Id</label>
                    <input
                        id="customerId"
                        type="text"
                        placeholder="Enter Customer Number"
                        value={customerNumber}
                        onChange={(e) => setCustomerNumber(e.target.value)}
                        disabled={isInputDisabled}
                        className={`${isValidating ? "hidden" : ""} p-2 border-2 border-black bg-[#FAECE7] rounded-lg flex-grow`}
                    />
                </div>
                <button
                    onClick={handleLoginClick}
                    disabled={!customerNumber}
                    className={`${flag ? "pointer-events-none opacity-50" : ""} w-48 h-12 mt-4 bg-white rounded-full font-semibold text-lg flex items-center justify-center cursor-pointer border border-black ${!customerNumber ? "opacity-50 cursor-not-allowed" : ""}`}
                >
                    LOG IN
                </button>
            </div>
            <p className="text-center text-sm mt-2 mb-4 leading-[1.65] font-gotham-rounded">
                For Svasti Microfinance<br />Customers Only
            </p>
            <img src={svasti_logo_footer} alt="Svasti Logo" className="w-[80%] mt-4 mb-2" />
            <div id="auth_footer_div" className="w-full text-center font-gotham-rounded mb-2">
                <p id="auth_footer" className="text-sm">Powered by SvasTech from Svasti Microfinance</p>
            </div>
        </div>
    );
};

export default Login;
